export default {
    root: {
        class: ['border-b border-gray-300'],
    },
};
